import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { formatDate } from '../utils/timeUtils';
import TemplateListView          from "./TemplateListView";
import AlarmRuleAdminDetailsView from "./AlarmRuleAdminDetailsView";
import AlarmRuleAdminNewView     from "./AlarmRuleAdminNewView";
import configInfo                from '../config/config.json';


const AlarmRuleAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "AlarmRuleAdmin.pageState";
  const defaultPageState = {
    searchField: "Code",
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Code"),
      sortable: true,
      sortField: 'code',
      grow: 2.5,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Alarm_category"),
      selector: row => row.category,
      sortable: true,
      sortField: 'category',
      grow: 2,
      wrap: true
    },
    ...configInfo.uiConfig.visibleFields.ALARMRULE_Class ?
    [{
      name: t("I18N_Alarm_class"),
      selector: row => t("I18N_" + row.class),
      sortable: true,
      sortField: 'class',
    }] : [],
    {
      name: t("I18N_Alarm_type"),
      selector: row => t("I18N_" + row.type),
      sortable: true,
      sortField: 'type',
    },
    {
      name: t("I18N_Status"),
      selector: row => t("I18N_" + row.status),
      sortable: true,
      sortField: 'status',
    },
    {
      name: t("I18N_Alarm_resume_time"),
      selector: row => formatDate(row.resumeTime),
      sortable: true,
      sortField: 'resumeTime',
      wrap: true
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  const searchFieldOptions = [
    { key: "CODE",  value: "CODE" },
    { key: "DESCRIPTION", value: "DESCRIPTION" }
  ];


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API}
                                                  apiObjName={'alarm-rules'}
                                                  listPageTitle={t("I18N_AlarmRule_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_alarm_rule")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Alarm_rule_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_alarm_rule")}
                                                  deleteObjNameField={"code"}
                                                  tableColumns={tableColumns}
                                                  searchFieldOptions={searchFieldOptions}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <AlarmRuleAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <AlarmRuleAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default AlarmRuleAdmin;
